import { render, staticRenderFns } from "./offerItem.vue?vue&type=template&id=7f74ff16&scoped=true"
import script from "./offerItem.vue?vue&type=script&lang=js"
export * from "./offerItem.vue?vue&type=script&lang=js"
import style0 from "./offerItem.vue?vue&type=style&index=0&id=7f74ff16&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f74ff16",
  null
  
)

export default component.exports